module.exports = __webpack_public_path__ + "static/media/rsz_kogsofficial.540c52ec.webp";